import React from "react";

const PrivacyPolicy = () => {
  document.title = "Privacy policy";

  return (
    <>
      <div className="container my-5">
        <h5>Privacy Policy</h5>

        <ol>
          <li>
            <b> Personal Information We Collect: </b>We may collect the
            following types of personal information from our website users: Name
            Email address Contact information (such as phone number, address)
            Educational and professional background Interests and preferences
          </li>
          <li>
            <b> How We Collect Information:</b> We collect personal information
            directly from you when you: Register an account on our website
            Complete a profile or survey Submit inquiries or requests
            Participate in events, workshops, or programs
          </li>
          <li>
            <b> How We Use Collected Information:</b> We may use the personal
            information we collect for the following purposes: To provide and
            personalize our services to you To facilitate student-industry
            engagement opportunities To communicate with you and respond to your
            inquiries To send you relevant updates, newsletters, or promotional
            materials To analyze and improve our website and user experience
          </li>
          <li>
            <b> How We Keep Information Safe: </b>We implement appropriate
            technical and organizational measures to protect your personal
            information against unauthorized access, disclosure, alteration, or
            destruction. Access to your personal information is restricted to
            authorized personnel only, and we regularly review and update our
            security measures to ensure the confidentiality and integrity of
            your data.
          </li>
          <li>
            <b>Information Sharing with Third Parties:</b> We do not sell,
            trade, or otherwise transfer your personal information to third
            parties without your consent, except as described in this Privacy
            Policy. We may share your personal information with trusted
            third-party service providers who assist us in operating our
            website, conducting business, or providing services to you, provided
            that they agree to keep your information confidential.
          </li>
          <p>
            By using our student and industry engagement website, you consent to
            the collection, use, and disclosure of your personal information as
            described in this Privacy Policy.
          </p>
          <li>
            <b> Updates to Privacy Policy:</b> We reserve the right to update or
            modify this Privacy Policy at any time without prior notice. Any
            changes to this policy will be effective immediately upon posting on
            our website.
          </li>

          <p className="my-3">
            Contact Us: &nbsp;
            <a href="mailto:yuvasarathi24@gmail.com">yuvasarathi24@gmail.com</a>
            &nbsp; or <b>9371001138</b>.
          </p>
        </ol>
      </div>
    </>
  );
};

export default PrivacyPolicy;
